import React from "react"
import { formatUserWithContactGroups } from "../../utils/assignees"

const Label = ({ children }) => (
  <span className="text-[12px] font-semibold uppercase tracking-[0.04em] text-text-secondary">{children}</span>
)

const AssigneeSplit = ({ affiliate, internal, userRole }) => (
  <div className="flex flex-col gap-3 text-[14px] text-text-secondary overflow-hidden">
    <div className="flex flex-col">
      <Label>Affiliate Assignee</Label>
      <span data-testid="affiliate-assignee" className="whitespace-normal">
        {affiliate ? `${affiliate.name}${affiliate.office ? ` (${affiliate.office})` : ''}` : '-'}
      </span>
    </div>
    <div className="flex flex-col">
      <Label>Internal Assignees</Label>
      <div data-testid="internal-assignees" className="flex flex-col">
        {internal.length > 0
          ? internal.map((assignee) => (
            <span key={assignee?._id || assignee?.id} className="whitespace-normal line-clamp-2">
              {userRole === 'affiliate'
                ? `${assignee?.firstName} ${assignee?.lastName}`
                : formatUserWithContactGroups({ user: assignee, userRole })}
            </span>
          ))
          : <span>-</span>}
      </div>
    </div>
  </div>
)

export default AssigneeSplit
